export const howWeTeach = {
  title: "How We Teach",
  subtitle: "Methodologies that guide our daily practice",
  items: {
    active: {
      title: "Active Pedagogy / Montessori",
      description: "The child as protagonist of their learning through prepared environments and manipulative materials"
    },
    global: {
      title: "Global Learning in English",
      description: "Progressive immersion: 40% in Early Years, 45% in Cycle 1, 50% in Cycle 2, with non-linguistic areas in English"
    },
    inclusion: {
      title: "Inclusion (UDL)",
      description: "Universal Design for Learning that guarantees accessibility and respects each student's diversity"
    },
    evaluation: {
      title: "Kind Evaluation",
      description: "Kind data: observation, pedagogical documentation and feedback that accompanies without labeling"
    }
  }
};
